import get from 'lodash/get';

import getCaseLogicSiblings from '../../utils/getCaseLogicSiblings';

function validateEndConditions(caseConf, nodeInfo, { isEffectChain }) {
  if (isEffectChain) {
    return;
  }
  const errors = [];
  const warnings = [];

  // If grading effects are being used, then don't validate end conditions
  const gradeEffectNodes = nodeInfo.effectNodes.filter(
    (node) => get(node, 'data.effect.type') === 'GRADING'
  );

  if (!gradeEffectNodes || !gradeEffectNodes.length) {
    const endNodes = nodeInfo.effectNodes.filter(
      (node) => get(node, 'data.effect.type') === 'GAME_END'
    );

    // Win Effect
    if (!endNodes.some((node) => get(node, 'data.effect.value') === true)) {
      warnings.push(caseLogicError('Scenario does not have a success effect.'));
    }

    // Lose Effect
    if (!endNodes.some((node) => get(node, 'data.effect.value') === false)) {
      warnings.push(caseLogicError('Scenario does not have a losing effect.'));
    }

    endNodes.forEach((endNode) => {
      const endCaseSiblings = getCaseLogicSiblings(endNode, caseConf.caseLogicDescription);
      endCaseSiblings.forEach(endCaseSiblingNode => {
        warnings.push({
          message:
            'Effects that happen at the same time as End Scenario will not occur.',
          category: 'caseLogic',
          field: 'caseLogicDescription',
          id: endCaseSiblingNode.id,
          metadata: {
            nodeId: endCaseSiblingNode.id,
          },
        });
      });
    });
  }

  return {
    errors,
    warnings,
  };
}

function caseLogicError(message) {
  return {
    message,
    category: 'caseLogic',
    field: 'caseLogicDescription',
    id: null,
    metadata: {
      defaultVisibility: false,
    },
  };
}


export default validateEndConditions;
